import styled from 'styled-components';
import { Row, Col } from 'antd';
import { FixedWidth } from '../../commonStyles';

export const FixedWidthContainer = styled(FixedWidth)`
  @media only screen and (max-width: 991px) {
    margin-top: -50px;
  }
`;

export const ErrorContentRow = styled(Row)`
  padding-top: 30px;
  @media only screen and (max-width: 991px) {
    display: flex;
    flex-direction: column-reverse;
  }
`;

export const ErrorContentCol = styled(Col)`
  @media only screen and (max-width: 991px) {
    width: 100%;
  }
  ${({ imageSection }) =>
    imageSection &&
    `
        @media only screen and (max-width: 991px) {
            justify-content: center;
            display: flex;
            width: 100%
            padding-top: 20px;
        }
    `}
`;

export const ErrorHead = styled.h2`
  font-family: HelveticaNeue-Light;
  font-size: 72px;
  line-height: 1;
  letter-spacing: 0.9px;
  color: rgb(227, 114, 34);
  @media only screen and (max-width: 991px) {
    margin-bottom: 20px;
  }
`;

export const ErrorDetail = styled.h3`
  font-family: BerkeleyStd-Book;
  color: rgb(2, 39, 55);
  font-size: 42px;
  line-height: 1.14;
  margin: 0px;
  @media only screen and (max-width: 991px) {
    font-size: 30px;
    line-height: 36px;
    letter-spacing: 0.36px;
    padding-bottom: 10px;
  }
`;

export const ErrorPara = styled.p`
  line-height: 1.5;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  font-family: helveticaNeue;
  color: #333333;
  padding-bottom: 40px;
  margin: 0px;
  @media only screen and (max-width: 991px) {
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0.44px;
  }
  ${({ bottom }) =>
    bottom &&
    `
        line-height: 30px;
        letter-spacing: 0.58px;
        padding: 0px;
        @media only screen and (max-width: 991px) {
            font-size: 14px;
            line-height: 30px;
            letter-spacing: 0.51px;
        }
    `}
`;

export const RevImage = styled.img`
  transform: rotate(180deg);
`;

export const ErrorImage = styled.img`
  width: 418.2px;
  height: 372.8px;
  @media only screen and (max-width: 991px) {
    width: 100%;
    height: auto;
    margin-bottom: 40px;
  }
`;

export const Links = styled.a`
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0.58px;
  color: #006778;
  text-decoration: underline;
  @media only screen and (max-width: 991px) {
    font-size: 14px;
    letter-spacing: 0.48px;
  }
`;
